/**
 * Created by tong on 2018/2/1.
 */
import React from 'react';
import Reflux from 'reflux';
import {categoryStore} from './store.js';
import {withRouter} from 'react-router';
import {Select, message} from 'antd';

const Option = Select.Option;
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {categoryList, customerScreening} from '../../service/creditChange';
import {getGouXiaoUnitList} from "../../service/traceOrder";
import moment from "moment/moment";

/*授信列表接口*/

class CategoryList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(categoryStore); //创建一个Store实例
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['授信变动记录'],
            channelCode: this.channelData.split('|')[1] || '',
            key: 0,
            rows: [],
            total: 0,
            customerName: [],
            thirdId: '',    //获取的客户名称的ID
            searchObj: {
                purchaseName: '',    // 购货单位
                projectName: '',     // 项目名称
                createTimeStart: moment().add(-1, 'y').format('YYYY-MM-DD'),// 起
                createTimeEnd: moment().format('YYYY-MM-DD'), // 止
                customerId: '',
                channelCode: this.channelData.split('|')[1] || '',
                p: 1,
                s: 10
            },
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.getData = this.getData.bind(this);
    };

    componentWillMount() {
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                }
            });
        }
        const {channelCode} = this.state;
        customerScreening(channelCode).then(res => { //客户类型
            self.setState({
                customerName: res.data,
            });
        })
    };

    /*客户名称选中*/
    cusNameChange = (value) => {
        const self = this;
        // console.log('Selected Id is: ' + value);
        this.setState({
                thirdId: value
            }, () => {
                self.getData();
            }
        );
    };

    componentDidMount() {
        this.getData();
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
    };

    /*获取页面列表*/
    getData() {
        const self = this;
        // console.log(this.state.thirdId);
        categoryList({
            purchaseName: this.state.searchObj.purchaseName,
            projectName: this.state.searchObj.projectName,
            startDate: this.state.searchObj.createTimeStart,
            endDate: this.state.searchObj.createTimeEnd,
            customerId: this.state.thirdId,
            channelCode: this.state.searchObj.channelCode,
            p: this.state.searchObj.p,
            s: this.state.searchObj.s
        }).then(result => {
            if (result.status) {
                self.setState({total: result.data.total, rows: result.data.data, loading: false});
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        });
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                customerId: this.customerId,
            }
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'startDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    createTimeStart: value.from,
                    createTimeEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                purchaseName: '',    // 购货单位
                projectName: '',     // 项目名称
                createTimeStart: '', // 起
                createTimeEnd: '', // 止
                p: 1,
                /*s: 10*/
            }, loading: true
        }, () => {
            self.getData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    };

    /*渲染*/
    render() {
        const {opts, rows, total, searchObj, customerName, loading, gouxiaoUnitList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'purchaseName',
                    defaultValue: searchObj.purchaseName,
                    label: '购货单位',
                    text: '请输入购货单位',
                    type: 'select',
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'startDate',
                    label: '时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.createTimeStart || '',
                        end: searchObj.createTimeEnd || ''
                    },
                },
                {
                    name: 'projectName',
                    defaultValue: searchObj.projectName,
                    label: '项目名称',
                    text: '请输入项目名称',
                    type: 'default'
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [{
                title: '变动日期',
                dataIndex: 'changeDate',
                render: text => new Date(text).format('yyyy-MM-dd')
            }, {
                title: '购货单位',
                dataIndex: 'salesUnitName',
            }, {
                title: '渠道',
                dataIndex: 'channelName',
            }, {
                title: '付款条件',
                dataIndex: 'payment',
            }, {
                title: '类型',
                dataIndex: 'type',
            }, {
                title: '授信额汇总',
                dataIndex: 'sxhzAmount',
            }, {
                title: '授信额',
                dataIndex: 'sxeAmount',
            }, {
                title: '可用额',
                dataIndex: 'kyAmount',
            }, {
                title: '备注',
                dataIndex: 'remark',
            }, /* {
                title: '项目编码',
                dataIndex: 'projectCode',
            }, {
				title: '项目名称',
				dataIndex: 'projectName',
			},*/ {
                title: '开始时间',
                dataIndex: 'startDate',

            }, {
                title: '截止时间',
                dataIndex: 'endDate',

            }, {
                title: '状态',
                dataIndex: 'status',
                render: text => text === "A" ? '有效' : '无效'
            },
            ],
            rows
        };
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}></DmsTab>
                    <div className="advanceForm-box">
                        <div className="advanceForm-content">
                            <AdvanceFormNew {...advanceProps}/>
                        </div>
                    </div>
                </div>
                <div style={{paddingTop: 16, paddingLeft: 12, background: '#fff'}}>
                    <label className="ant-form-item-required">客户名称：</label>
                    <Select
                        style={{width: 240}}
                        placeholder='请选择客户名称获取列表数据'
                        onChange={this.cusNameChange}
                    >
                        {customerName.map(function (item, key) {
                            return <Select.Option key={key + ''} value={item.thirdId + ''}>{item.name}</Select.Option>
                        })}
                    </Select>
                </div>

                <div className="dms-table-box">
                    <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                        <span><font size={1} style={{color: 'red'}}>默认显示一年内数据</font></span>
                    </div>
                    <TableView {...tableViewProps} />
                </div>
            </div>
        )
    }
}

export default withRouter(CategoryList);



// WEBPACK FOOTER //
// ./src/routes/creditChange/list.js